module.exports = __webpack_public_path__ + "static/media/close_popup.70ff1785.svg";